import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss'],
})
export class ServiceUnavailableComponent {
  @HostBinding('class.errors') public hasErrors: boolean = true;
  public heading: string;
  public subHeading: string;

  constructor() {
    this.heading = 'Software download is unavailable at this time.';
    this.subHeading = 'Please check back later.';
  }
}
